<template :key="$route.fullPath">
  <DefaultLayout>
    <section class="product-shop spad">
      <!-- Mobile Filter Toggle Button -->
      <button @click="showMobileFilters = !showMobileFilters" class="mobile-filter-toggle">
        <span>{{ showMobileFilters ? $t("sentence.hideFilters") : $t("sentence.showFilters") }}</span>
        <i class="toggle-icon" :class="showMobileFilters ? 'mdi mdi-close' : 'mdi mdi-menu'"></i>
      </button>
      <div class="content">
        <div class="page-container">
          <!-- Mobile Overlay -->
          <div v-if="showMobileFilters" class="mobile-overlay" @click="showMobileFilters = false"></div>

          <div class="filters-sidebar" :class="{ 'show-mobile': showMobileFilters }">

             <!-- Sold Status Filter with Finished Auctions -->
            <div class="filter-group">
              <h4 class="fw-title">{{ $t("sentence.productStatus") }}</h4>
              <label class="filter-radio-label">
                <input type="radio" name="soldStatus" :checked="filters.has_been_sold === 'all'"
                  @change="updateSoldStatus('all')">
                <span>{{ $t("general.all") }}</span>
              </label>
              <label class="filter-radio-label">
                <input type="radio" name="soldStatus" :checked="filters.has_been_sold === '0'"
                  @change="updateSoldStatus('0')">
                <span>{{ $t("sentence.availableProducts") }}</span>
              </label>

              <label class="filter-radio-label">
                <input type="radio" name="soldStatus" :checked="filters.has_been_sold === 'finished'"
                  @change="updateSoldStatus('finished')">
                <span>{{ $t("sentence.finishedAuctions") }}</span>
              </label>
              <label class="filter-radio-label">
                <input type="radio" name="soldStatus" :checked="filters.has_been_sold === '1'"
                  @change="updateSoldStatus('1')">
                <span>{{ $t("sentence.productSold") }}</span>
              </label>
            </div>
            
            <!-- Price Range Filter -->
            <div class="filter-widget-table">
              <h4 class="fw-title">{{ $t("main.priceRange") }}</h4>
              <div class="price-filter-inputs">
                <div class="price-input-group">
                  <label>{{ $t("main.min") }}</label>
                  <input type="number" v-model.number="filters.minPrice" :placeholder="minValue.toString()"
                    class="filter-input price-input" min="0" @input="debouncedPriceFilter">
                </div>
                <div class="price-input-group">
                  <label>{{ $t("main.max") }}</label>
                  <input type="number" v-model.number="filters.maxPrice" :placeholder="maxValue.toString()"
                    class="filter-input price-input" min="0" @input="debouncedPriceFilter">
                </div>
              </div>
              <div class="price-range-display" v-if="filters.minPrice || filters.maxPrice">
                <span class="price-badge">
                  {{ formatPrice(filters.minPrice || minValue) }} -
                  {{ formatPrice(filters.maxPrice || maxValue) }}
                </span>
              </div>
            </div>

            <!-- Type of Sale Filter -->
            <div class="filter-group">
              <h4 class="fw-title">{{ $t("main.typeOfSale") }}</h4>
              <label class="filter-radio-label">
                <input type="radio" name="typeOfSale" :checked="filters.typeOfSale === 'all'"
                  @change="updateTypeOfSale('all')">
                <span>{{ $t("general.all") }}</span>
              </label>
              <label class="filter-radio-label">
                <input type="radio" name="typeOfSale" :checked="filters.typeOfSale === 'fixed'"
                  @change="updateTypeOfSale('fixed')">
                <span>{{ $t("ecommerce.fixed-price") }}</span>
              </label>
              <label class="filter-radio-label">
                <input type="radio" name="typeOfSale" :checked="filters.typeOfSale === 'auction'"
                  @change="updateTypeOfSale('auction')">
                <span>{{ $t("ecommerce.auction") }}</span>
              </label>
            </div>

           

            <!-- Product Condition Filter -->
            <div class="filter-group">
              <h4 class="fw-title">{{ $t("product.condition") }}</h4>
              <div class="filter-radio-group">
                <label v-for="(state, index) in optionsCondition" :key="index" class="filter-radio-label">
                  <input type="radio" name="productCondition" :value="state" :checked="filters.state === state"
                    @change="updateState(state)">
                  <span>{{ state }}</span>
                </label>
              </div>
            </div>
<!-- Categories Filter -->
            <div class="filter-widget-table">
              <h4 class="fw-title">{{ $t("main.categories") }}</h4>
              <ul class="filter-checkbox-list" v-if="categories && categories.length > 0">
                <li v-for="category in categories.filter(c => c.parent_id === 0)" :key="category.id">
                  <label class="filter-checkbox-label">
                    <input type="checkbox" :value="category.id" :checked="isCategorySelected(category.id)"
                      @change="toggleCategoryFilter(category.id)">
                    <span>{{ category.label }}</span>
                  </label>
                </li>
              </ul>
              <div v-else>{{ $t("sentence.loadingMore") }}</div>
            </div>

            <button @click="clearAllFilters" class="btn-clear-filters">
              {{ $t("sentence.clearFilters") }}
            </button>
          </div>

          <div class="results-area">
            <div class="loader" v-if="loader"></div>
            <div class="top-bar">
              <!-- Product Name Filter -->
              <div class="search-container">
                <div class="search-input-group">
                  <input type="text" class="search-input" v-model="searchName"
                    :placeholder="$t('sentence.searchByName')" @input="debouncedNameFilter" />
                  <i :class="isFilteredBySearch ? 'mdi-close' : 'mdi-magnify'" @click="clearSearchName"
                    class="mdi search-nav-icon"></i>
                </div>
              </div>
              <div class="ml-md-3 sort-select">
                <v-select :value="selectedSort" :options="optionsListOrder" @input="setListOrder"></v-select>
              </div>
            </div>

            <!-- activeFilters -->
            <div class="current-filters-section" v-if="activeFilters.length > 0">
              <label class="label-control">{{ $t("sentence.currentFilter") }}</label>
              <ul class="filter-tags">
                <li v-for="(filter, index) in activeFilters" :key="index" class="filter-tag">
                  <div class="tag-content">
                    <span>{{ filter.label }}</span>
                  </div>
                  <div @click="removeFilter(filter.type, filter.value)" class="tag-remove">
                    <i class="mdi mdi-close"></i>
                  </div>
                </li>
              </ul>
            </div>
            <div class="result-count">
              <span>{{ $t('found_products', { count: products.length }) }}</span>
            </div>
            <div class="products-grid" v-if="loader == false">
              <ProductSingle v-for="product in products" :key="product.id" :product="product" />
            </div>

            <div class="alert alert-danger text-center" v-show="emptyProduct">
              {{ $t("sentence.noProductFound") }}
            </div>

            <div class="loading-more" v-show="!emptyProduct && hasMoreProducts">
              <button @click="loadMore" class="btn btn-primary">
                {{ $t("sentence.seeMore") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </DefaultLayout>
</template>


<script>
import ProductSingle from "@/components/templates/ProductSingle.vue";
import vSelect from "vue-select";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import helper from "@/services/helper";

export default {
  name: "ProductsFilters",
  data() {
    return {
      limit: 60,
      offset: 0,
      products: [],
      emptyProduct: false,
      maxValue: 0,
      minValue: 0,
      showMobileFilters: false,
      optionsCondition: [
        "All",
        this.$t("product.state.new-in-packaging"),
        this.$t("product.state.new"),
        this.$t("product.state.very-good"),
        this.$t("product.state.good"),
        this.$t("product.state.old"),
      ],
      filters: {
        categories: [],
        state: "All",
        minPrice: null,
        maxPrice: null,
        typeOfSale: "all",
        has_been_sold: "0",
      },
      optionsListOrder: [
        { label: "Pertinence", value: "Default" },
        { label: "Durée : ventes se terminant en premier", value: "Time: Ending soon" },
        { label: "Durée : nouveaux objets", value: "Time: Newly listed" },
        { label: "Objets les moins chers", value: "Price: Lowest First" },
        { label: "Objets les plus chers", value: "Price: Highest First" },
        { label: "État : objets neufs", value: "State: New" },
        { label: "État : objets d'occasion", value: "State: Used" }
      ],
      selectedSort: { label: "Pertinence", value: "Default" },
      searchName: "",
      loader: false,
      debounceTimer: null,
      priceDebounceTimer: null,
      hasMoreProducts: true,
    };
  },
  components: {
    "v-select": vSelect,
    ProductSingle,
    DefaultLayout,
  },
  mounted() {
    // Initialize filters from route query parameters
    this.initializeFiltersFromRoute();
    this.getProducts();
  },
  computed: {
    categories() {
      return this.$store.getters.categories;
    },
    activeFilters() {
      const filters=[];

      // Category filters
      this.filters.categories.forEach(categoryId => {
        const category=this.getCategoryById(categoryId);
        if (category) {
          filters.push({
            type: 'category',
            value: categoryId,
            label: category.label
          });
        }
      });

      // Price range filter
      if (this.filters.minPrice||this.filters.maxPrice) {
        const min=this.filters.minPrice||this.minValue;
        const max=this.filters.maxPrice||this.maxValue;
        filters.push({
          type: 'priceRange',
          value: null,
          label: `${this.formatPrice(min)} - ${this.formatPrice(max)}`
        });
      }

      // Product name filter
      if (this.searchName&&this.searchName.trim()!=='') {
        filters.push({
          type: 'productName',
          value: null,
          label: `${this.$t("attr.name")}: ${this.searchName}`
        });
      }

      // State filter
      if (this.filters.state!=="All") {
        filters.push({
          type: 'state',
          value: this.filters.state,
          label: `${this.$t("product.condition")}: ${this.filters.state}`
        });
      }

      // Type of sale filter
      if (this.filters.typeOfSale!=='all') {
        const label=this.filters.typeOfSale==='fixed'
          ? this.$t("ecommerce.fixed-price")
          :this.$t("ecommerce.auction");
        filters.push({
          type: 'typeOfSale',
          value: this.filters.typeOfSale,
          label: `${this.$t("main.typeOfSale")}: ${label}`
        });
      }

      if (this.filters.has_been_sold!=="0") {
        let label;
        if (this.filters.has_been_sold==="1") {
          label=this.$t("sentence.productSold");
        } else if (this.filters.has_been_sold==="finished") {
          label=this.$t("sentence.finishedAuctions");
        } else {
          label=this.$t("general.all");
        }

        filters.push({
          type: "has_been_sold",
          value: this.filters.has_been_sold,
          label,
        });
      }

      return filters;
    },
    isFilteredBySearch() {
      return this.$route.query &&
        this.$route.query.search &&
        this.$route.query.search.trim() !== '';
    }
  },
  methods: {
    clearSearchName() {
      this.searchName='';
      this.updateRouteQuery();
    },
    toggleCategoryFilter(categoryId) {
      const index=this.filters.categories.indexOf(categoryId);
      if (index>-1) {
        this.filters.categories.splice(index, 1);
      } else {
        this.filters.categories.push(categoryId);
      }
      this.updateRouteQuery();
    },
    clearAllFilters() {
      this.filters={
        categories: [],
        state: "All",
        minPrice: null,
        maxPrice: null,
        typeOfSale: "all",
        has_been_sold: "all",
      };
      this.searchName="";
      this.selectedSort="Default";
      this.updateRouteQuery();
      if (window.innerWidth<=992) {
        this.showMobileFilters=false;
      }
    },
    isCategorySelected(categoryId) {
      return this.filters.categories.includes(categoryId);
    },

    updateTypeOfSale(value) {
      this.filters.typeOfSale=value;
      this.updateRouteQuery();
    },

    updateSoldStatus(value) {
      this.filters.has_been_sold=value;
      this.updateRouteQuery();
    },

    updateState(value) {
      this.filters.state=value;
      this.updateRouteQuery();
    },

    debouncedNameFilter() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer=setTimeout(() => {
        this.updateRouteQuery();
      }, 500);
    },

    debouncedPriceFilter() {
      clearTimeout(this.priceDebounceTimer);
      this.priceDebounceTimer=setTimeout(() => {
        this.updateRouteQuery();
      }, 800);
    },

    removeFilter(type, value) {
      if (type==='category') {
        const index=this.filters.categories.indexOf(value);
        if (index>-1) {
          this.filters.categories.splice(index, 1);
        }
      } else if (type==='priceRange') {
        this.filters.minPrice=null;
        this.filters.maxPrice=null;
      } else if (type==='productName') {
        this.clearSearchName();
      } else if (type==='state') {
        this.filters.state='All';
      } else if (type==='typeOfSale') {
        this.filters.typeOfSale='all';
      } else if (type==='has_been_sold') {
        this.filters.has_been_sold='all';
      }
      this.updateRouteQuery();
    },

    updateRouteQuery() {
      const query={};

      // Add categories to query
      if (this.filters.categories.length>0) {
        query.categories=this.filters.categories.join(',');
      }

      // Add price range to query
      if (this.filters.minPrice) {
        query.minPrice=this.filters.minPrice;
      }
      if (this.filters.maxPrice) {
        query.maxPrice=this.filters.maxPrice;
      }

      // Add state to query
      if (this.filters.state!=='All') {
        query.state=this.filters.state;
      }

      // Add type of sale to query
      if (this.filters.typeOfSale!=='all') {
        query.typeOfSale=this.filters.typeOfSale;
      }

      // Add search to query
      if (this.searchName&&this.searchName.trim()!=='') {
        query.search=this.searchName.trim();
      }

      // Add has_been_sold to query (only if not "0" - default)
      if (this.filters.has_been_sold!=="0") {
        query.has_been_sold=this.filters.has_been_sold;
      }
      if (this.selectedSort.value!=='Default') {
        query.sort=this.selectedSort.value;
      }

      this.$router.push({ query }).catch(() => { });
    },

    initializeFiltersFromRoute() {
      const query=this.$route.query;

      // Initialize categories from route
      if (query.categories) {
        this.filters.categories=query.categories.split(',').map(id => parseInt(id));
      } else if (this.$route.params.id) {
        const categoryId=parseInt(this.$route.params.id);
        this.filters.categories=[categoryId];
      }

      // Initialize price range from route
      if (query.minPrice) {
        this.filters.minPrice=parseFloat(query.minPrice);
      }
      if (query.maxPrice) {
        this.filters.maxPrice=parseFloat(query.maxPrice);
      }

      // Initialize state from route
      if (query.state) {
        this.filters.state=query.state;
      }

      // Initialize type of sale from route
      if (query.typeOfSale) {
        this.filters.typeOfSale=query.typeOfSale;
      }

      // Initialize search from route
      if (query.search) {
        this.searchName=query.search;
      }

      if (query.sort) {
        const sortOption=this.optionsListOrder.find(opt => opt.value===query.sort);
        if (sortOption) {
          this.selectedSort=sortOption;
        }
      }

      // Initialize has_been_sold from route
      if (query.has_been_sold!==undefined) {
        this.filters.has_been_sold=query.has_been_sold;
      } else {
        this.filters.has_been_sold="0";  // default
      }
    },

    resetAndFetchProducts() {
      this.offset=0;
      this.products=[];
      this.hasMoreProducts=true;
      this.emptyProduct=false;
      this.getProducts();
    },

    formatPrice: helper.formatPrice,

    setListOrder(value) {
      this.selectedSort=value;
      this.updateRouteQuery();
    },

    loadMore() {
      this.getProducts();
    },

    buildQueryParams() {
      const params=new URLSearchParams();

      params.append('offset', this.offset);
      params.append('limit', this.limit);

      // Handle has_been_sold parameter
      if (this.filters.has_been_sold!=='all') {
        params.append('has_been_sold', this.filters.has_been_sold);
      }

      // Add category filters
      if (this.filters.categories.length>0) {
        params.append('categories', this.filters.categories.join(','));
      }

      // Add price range
      if (this.filters.minPrice) {
        params.append('minPrice', this.filters.minPrice);
      }
      if (this.filters.maxPrice) {
        params.append('maxPrice', this.filters.maxPrice);
      }

      // Add state filter
      if (this.filters.state!=='All') {
        params.append('state', this.filters.state);
      }

      // Add type of sale
      if (this.filters.typeOfSale!=='all') {
        params.append('typeOfSale', this.filters.typeOfSale);
      }

      // Add search name
      if (this.searchName&&this.searchName.trim()!=='') {
        params.append('search', this.searchName.trim());
      }

      // Add sort order
      if (this.selectedSort.value!=='Default') {
        params.append('sort', this.selectedSort.value);
      }

      return params.toString();
    },

    getProducts() {
      const self=this;
      let url="product/list";
      self.loader=true;

      if (this.$route.params.id!=undefined) {
        url+="/"+this.$route.params.id;
      }

      const queryParams=this.buildQueryParams();

      this.$axios({
        url: url+"?"+queryParams,
        method: "GET",
      })
        .then((response) => {
          if (response.data.products.length<self.limit) {
            self.hasMoreProducts=false;
          }

          self.products=self.products.concat(response.data.products);

          self.calculatePriceRange();
          self.offset+=self.limit;

          if (self.products.length===0&&self.offset===self.limit) {
            self.emptyProduct=true;
          }

          self.loader=false;
        })
        .catch(function (err) {
          console.log(err);
          self.loader=false;
        });
    },

    calculatePriceRange() {
      if (this.products.length===0) return;

      const prices=this.products.map(product => this.getProductPrice(product));
      this.maxValue=Math.max(...prices);
      this.minValue=Math.min(...prices);
    },

    getProductPrice(product) {
      if (product.sales_type==="auction"&&product.bids&&product.bids.length>0) {
        return product.bids[0].price;
      }
      if (product.sales_type==="fixed") {
        return product.fixed_price;
      }
      return product.starting_price;
    },

    getCategoryById(id) {
      if (!this.categories) return null;
      return this.categories.find(cat => cat.id===id);
    },
  },
  watch: {
    '$route.query': {
      handler: function (newQuery, oldQuery) {
        // Only fetch if query actually changed
        if (JSON.stringify(newQuery)!==JSON.stringify(oldQuery)) {
          this.initializeFiltersFromRoute();
          this.resetAndFetchProducts();
        }
      },
      deep: true
    },
    '$route.params.id': function (newId) {
      // Reset when category changes via params
      this.offset=0;
      this.products=[];
      this.hasMoreProducts=true;

      if (newId) {
        const categoryId=parseInt(newId);
        this.filters.categories=[categoryId];
        this.updateRouteQuery();
      } else {
        this.filters.categories=[];
        this.updateRouteQuery();
      }
    }
  }
};
</script>

<style scoped>
.product-shop {
  background-color: var(--color-light);
  padding: 20px 0;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.mobile-filter-toggle {
  display: none;
  width: 100%;
  padding: 12px 20px;
  background: var(--color-nz);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 15px;
  align-items: center;
  justify-content: space-between;
  transition: background 0.3s;
}

.toggle-icon {
  font-size: 20px;
  margin-inline-start: 10px;
}

.page-container {
  display: flex;
  gap: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.filters-sidebar {
  width: 280px;
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  height: fit-content;
  position: sticky;
  top: 20px;
}

.filter-widget-table {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.filter-widget-table:last-of-type {
  border-bottom: none;
}

.fw-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.filter-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--color-c);
  color: var(--color-2);
  border-radius: 6px;
  font-size: 24px;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.filter-input:focus {
  outline: none;
  border-color: var(--color-nz);
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.filter-input::placeholder {
  color: #999;
}

.price-filter-inputs {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}

.price-input-group {
  flex: 1;
}

.price-input-group label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #555;
  margin-bottom: 6px;
}

.price-input {
  width: 100%;
  padding: 8px 10px;
  font-size: 14px;
}

.price-range-display {
  margin-top: 10px;
  text-align: center;
}

.price-badge {
  width: 100%;
  display: inline-block;
  background: #f0f0f0;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.filter-checkbox-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.filter-checkbox-list li {
  margin-bottom: 8px;
}

.filter-checkbox-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #555;
  cursor: pointer;
  padding: 6px 8px;
  border-radius: 4px;
  transition: background-color 0.2s, color 0.2s;
}

.filter-checkbox-label:hover {
  background-color: var(--light);
  color: var(--color-nz);
}

.filter-checkbox-label input[type="checkbox"] {
  margin-right: 10px;
  cursor: pointer;
  width: 16px;
  height: 16px;
  accent-color: var(--color-nz);
}

.filter-group {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.filter-group:last-child {
  border-bottom: none;
}

.filter-radio-group {
  display: flex;
  flex-direction: column;
}

.filter-radio-label {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #555;
  padding: 6px 8px;
  border-radius: 4px;
  transition: background-color 0.2s, color 0.2s;
}

.filter-radio-label:hover {
  background-color: var(--light);
  color: var(--color-nz);
}

.filter-radio-label input[type="radio"] {
  margin-right: 10px;
  cursor: pointer;
  width: 16px;
  height: 16px;
  accent-color: var(--color-nz);
}

.btn-clear-filters {
  width: 100%;
  padding: 12px;
  background: transparent;
  color: #666;
  border: 2px solid #ddd;
  border-radius: 6px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  transition: all 0.3s;
}

.btn-clear-filters:hover {
  background: var(--light);
  border-color: #999;
  color: #333;
}

.btn-clear-filters:active {
  transform: scale(0.98);
}

.results-area {
  flex: 1;
  min-width: 0;
}

.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  background: white;
  padding: 15px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.result-count {
  font-size: 16px;
  font-weight: 500;
  color: var(--color-3);
  margin-bottom: 1rem;
}

.sort-select {
  min-width: 200px;
}

.current-filters-section {
  background: white;
  padding: 15px 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.label-control {
  font-size: 14px;
  font-weight: 600;
  color: #666;
  margin-bottom: 10px;
  display: block;
}

.filter-tags {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.filter-tag {
  display: inline-flex;
  align-items: center;
  background: var(--color-nz);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 13px;
  gap: 8px;
}

.tag-content {
  display: flex;
  align-items: center;
}

.tag-remove {
  cursor: pointer
}


@media (max-width: 992px) {
  .mobile-filter-toggle {
    display: flex;
    width: 92%;
    margin: 0 auto;
  }

  .page-container {
    flex-direction: column;
  }

  /* Mobile Overlay - visible when filters are shown */
  .mobile-overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }

  .filters-sidebar {
    width: auto;
    position: fixed;
    top: 0;
    left: -100%;
    height: 100vh;
    z-index: 1000;
    overflow-y: auto;
    transition: left 0.3s ease-in-out;
    max-width: 320px;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.2);
  }

  .filters-sidebar.show-mobile {
    left: 0;
  }

  /* Remove the old pseudo-element overlay */
  .filters-sidebar.show-mobile::before {
    display: none;
  }

  .products-grid {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
}

@media (max-width: 992px) {


  .filters-sidebar {
    width: auto;
    position: fixed;
    top: 0;
    left: -100%;
    height: 100vh;
    z-index: 1000;
    overflow-y: auto;
    transition: left 0.3s ease-in-out;
    max-width: 320px;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.2);
  }

  .filters-sidebar.show-mobile {
    left: 0;
  }

  /* Overlay for mobile filters */
  .filters-sidebar.show-mobile::before {
    content: '';
    position: fixed;
    top: 0;
    left: 320px;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: -1;
  }

  .products-grid {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
}

@media (max-width: 768px) {
  .top-bar {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }

  .sort-select {
    width: 100%;
  }

  .products-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 15px;
  }

  .price-filter-inputs {
    flex-direction: column;
  }

  .filters-sidebar {
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .filters-sidebar {
    border-radius: 6px;
  }

  .btn-clear-filters {
    font-size: 14px;
    padding: 10px;
  }
}
</style>